import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

export default function PracticeCard({ area, index = 0 }) {
  const Icon = area.icon;
  return (
    <Link
      to={`/practice-areas/${area.slug}`}
      data-testid={`practice-card-${area.slug}`}
      className="group relative flex flex-col justify-between overflow-hidden rounded-sm border border-navy-900/10 bg-white p-7 md:p-8 transition-all duration-300 hover:-translate-y-1 hover:border-gold/60 hover:shadow-[0_30px_60px_-30px_rgba(10,25,47,0.3)]"
    >
      <div className="absolute -right-12 -top-12 h-44 w-44 rounded-full bg-gold/5 opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
      <div className="relative">
        <div className="flex items-start justify-between">
          <div className="h-12 w-12 rounded-sm bg-gold/10 grid place-items-center group-hover:bg-gold transition-colors duration-300">
            <Icon className="h-6 w-6 text-gold group-hover:text-navy-950 transition-colors duration-300" />
          </div>
          <span className="text-[11px] uppercase tracking-[0.2em] text-navy-900/30 font-medium">
            {String(index + 1).padStart(2, "0")}
          </span>
        </div>
        <h3 className="font-display text-2xl md:text-[1.6rem] mt-7 text-navy-900 leading-tight">
          {area.title}
        </h3>
        <p className="mt-3 text-[0.95rem] text-navy-900/60 leading-relaxed">
          {area.short}
        </p>
      </div>
      <div className="relative mt-8 flex items-center justify-between">
        <span className="text-sm font-semibold text-navy-900 group-hover:text-gold transition-colors">
          Learn more
        </span>
        <ArrowUpRight className="h-5 w-5 text-gold transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1" />
      </div>
    </Link>
  );
}
